import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.checkright');
import { Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, NgZone } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-checkright',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.checkright/view.scss */
/* src/app/component.checkright/view.scss: no such file or directory */`],
})
export class ComponentCheckrightComponent implements OnChanges {
  @Input() selectedQA: any;
  @Output() reviewComplete = new EventEmitter<any>(); // ✅ 부모로 전달할 이벤트

  public rating: number = 0;
  public comment: string = "";

  constructor(@Inject( Service)     public service: Service,@Inject( ChangeDetectorRef)     private cdr: ChangeDetectorRef,@Inject( NgZone  )     private zone: NgZone  ) {}

  // ===============================
  // Q&A 변경 감지
  // ===============================
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedQA"]) {
      console.log("✅ selectedQA 변경 감지:", this.selectedQA);

      this.zone.run(() => {
        this.rating = 0; // 새 Q&A 선택 시 초기화
        this.comment = "";
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      });
    }
  }

  // ===============================
  // 평가 점수 설정
  // ===============================
  public setRating(star: number): void {
    this.rating = star;
    this.cdr.detectChanges();
  }

  // ===============================
  // 승인 처리
  // ===============================
  public approveQA(): void {
    if (!this.selectedQA) return;

    const result = {
      ...this.selectedQA,
      status: "승인",
      rating: this.rating,
      comment: this.comment,
    };

    console.log("✅ 승인 완료:", result);

    // ✅ 부모로 결과 전송
    this.zone.run(() => {
      this.reviewComplete.emit(result);
      this.resetForm();
    });
  }

  // ===============================
  // 반려 처리
  // ===============================
  public rejectQA(): void {
    if (!this.selectedQA) return;

    const result = {
      ...this.selectedQA,
      status: "반려",
      rating: this.rating,
      comment: this.comment,
    };

    console.log("❌ 반려 완료:", result);

    // ✅ 부모로 결과 전송
    this.zone.run(() => {
      this.reviewComplete.emit(result);
      this.resetForm();
    });
  }

  // ===============================
  // 폼 리셋
  // ===============================
  private resetForm(): void {
    this.rating = 0;
    this.comment = "";
    this.selectedQA = null;
    this.cdr.detectChanges();
  }
}

export default ComponentCheckrightComponent;